import { all, call, put, takeEvery } from 'redux-saga/effects';
import { fetchEntity, fetchEntityIfNeeded } from '@classpass/saga-tools';
import { ec } from 'helpers/multitrack';
import { segment } from 'helpers/segment';
import {
  cancelReservation,
  createReservation,
  similarVenues,
  userActionCampaignEvent,
  userProfile,
} from 'redux/saga/entities/bound';
import { getUserId } from 'redux/saga/helpers';
import { readSessionStorage } from 'redux/saga/helpers/local-storage';

const CANCEL_RESERVATION = 'Reservation/CANCEL_RESERVATION';
const REQUEST_RESERVATION = 'Reservation/REQUEST_RESERVATION';
const RESERVATION_STATUS_CHANGED = 'Reservation/RESERVATION_STATUS_CHANGED';

export const requestCancelReservation = reservationId => ({ type: CANCEL_RESERVATION, reservationId });
export const requestReservation = (scheduleId, venueId, reservationParams, trackingParams) => ({
  type: REQUEST_RESERVATION,
  scheduleId,
  venueId,
  reservationParams,
  trackingParams,
});
export const reservationStatusChanged = () => ({ type: RESERVATION_STATUS_CHANGED });

export function* trackReservation(scheduleId, reservationId = 0, params) {
  const trackingParams = {
    url: window.location.pathname,
    schedule_id: scheduleId,
    reservation_id: reservationId,
    failed: false,
    top_up: false,
    top_up_price: null,
    top_up_credit_amount: null,
    ...(yield call(readSessionStorage, `schedule_${scheduleId}`, {})),
    ...params,
  };

  yield call(segment.track, 'Reserve Schedule', trackingParams);

  yield call(ec, 'Reserve Schedule', trackingParams);
}

export function* doCancelReservation(client, { reservationId }) {
  const userId = yield call(getUserId);

  yield call(fetchEntity, cancelReservation, [client, userId, reservationId, { state: 'cancel' }]);
  yield put(reservationStatusChanged());
}

export function* doReserveClass(client, { scheduleId, venueId, reservationParams = {}, trackingParams = {} }) {
  try {
    const user = yield call(fetchEntityIfNeeded, userProfile, [client]);
    const params = {
      schedule: scheduleId,
      ...reservationParams,
    };

    const reservation = yield call(fetchEntity, createReservation, [client, user.id, params]);

    yield all([
      put(reservationStatusChanged()),
      call(trackReservation, scheduleId, reservation.id, trackingParams),
      call(fetchEntityIfNeeded, similarVenues, [client, venueId]),
      call(fetchEntity, userActionCampaignEvent, [
        client,
        'ReservationSuccess',
        {
          id: reservation.id,
          ignore_cooldown: true,
        },
      ]),
    ]);
  } catch (e) {
    yield call(trackReservation, scheduleId, undefined, {
      ...trackingParams,
      failed: true,
    });
  }
}

export function* watchCancelReservation(client) {
  yield takeEvery(CANCEL_RESERVATION, doCancelReservation, client);
}

export function* watchRequestReservation(client) {
  yield takeEvery(REQUEST_RESERVATION, doReserveClass, client);
}
